import React, { useMemo, useState } from "react";
import { useTranslation } from "src/context/Translations/context";
import { RCCGrid, RCCInput, RCCSwitch } from "react-common-components";
import Audit from "src/components/Audit";
import { useAuth } from "src/context/Auth/context";

import Title from "src/components/Title";
import { IComponentAnalysis } from "./interface";
import FormStandardsFields from "./formStandardsFields";

const TabAnalysisGeneral: React.FC<IComponentAnalysis> = ({
	isDisabled,
	isAdd,
	data,
	register,
	unregister,
	control,
	error,
	watch,
	setValue,
	onChangeAnalysisModel
}) => {
	const { translate } = useTranslation();
	const { superUser, businessGroup } = useAuth();
	const [graficoRadar, setGraficoRadar] = useState<boolean>(data.maa001Graficoradar !== "N");
	const [disabledGraficoRadar, setDisabledGraficoRadar] = useState<boolean>(data.maa001Gut === "N");

	const onChangeGut = (item: any) => {
		unregister("maa001Graficoradar");
		const {checked} = item.target;

		setGraficoRadar(checked);
		setDisabledGraficoRadar(!checked);

		setValue("maa001Graficoradar", checked);
	};

	const SwitchGraficoRadar = useMemo(() => (
		<>
			<RCCSwitch styleInline="margin: 10px 10px"
				name="maa001Graficoradar" 
				label={translate("Utiliza Gráfico Radar")} 
				register={register} 
				defaultChecked={graficoRadar}
				disabled={isDisabled || disabledGraficoRadar}
			/>
		</>
	), [graficoRadar, disabledGraficoRadar]);

	return (
		<RCCGrid
			container	
			item
			direction="column"
			alignItems="center"
			justifyContent="flex-start"
		>
			<RCCGrid 
				container
				item
				xs={12}
				sm={10}
				alignItems="center"
				justify="flex-end"
			>
				<Audit data={data} type="pop"/>
			</RCCGrid>
			
			<FormStandardsFields 
				isDisabled={isDisabled}
				isAdd={isAdd}
				data={data}
				register={register}
				unregister={unregister}
				control={control}
				error={error}
				watch={watch}
				setValue={setValue}
				onChangeAnalysisModel={onChangeAnalysisModel}
			/>
			<RCCGrid 
				container 
				item
				xs={12}
				sm={10}
			>
				<RCCInput 
					name="maa001Label1"
					register={register}
					label={translate("Label 1")}
					defaultValue={data.maa001Label1}
					error={error.maa001Label1}
					maxLength={60}
					required
					disabled={isDisabled}
				/>
			</RCCGrid>
			<RCCGrid 
				container 
				item
				xs={12}
				sm={10}
			>
				<RCCInput 
					name="maa001Label2"
					register={register}
					label={translate("Label 2")}
					defaultValue={data.maa001Label2}
					error={error.maa001Label2}
					maxLength={60}
					required
					disabled={isDisabled}
				/>
			</RCCGrid>
			<RCCGrid 
				container 
				item
				xs={12}
				sm={10}
			>
				<RCCInput 
					name="maa001Label3"
					register={register}
					label={translate("Label 3")}
					defaultValue={data.maa001Label3}
					error={error.maa001Label3}
					maxLength={60}
					required
					disabled={isDisabled}
				/>
			</RCCGrid>
			<RCCGrid 
				container 
				item
				xs={12}
				sm={10}
			>		
				<RCCGrid
					container
					item
					md={6}
					xs={12}
				>
					<RCCSwitch styleInline="margin: 10px 10px"
						name="maa001Gut" 
						label={translate("Utiliza GUT")} 
						register={register} 
						defaultChecked={data.maa001Gut !== "N"}
						onChangeCapture={(x) => onChangeGut(x)}
						disabled={isDisabled}
					/>
				</RCCGrid>
				<RCCGrid
					container
					item
					md={6}
					xs={12}
				>
					{SwitchGraficoRadar}
				</RCCGrid>
				<RCCGrid
					container
					item
					md={6}
					xs={12}
				>
					<RCCSwitch styleInline="margin: 10px 10px"
						name="maa001Adicionanivel1" 
						label={translate("Permite adicionar elementos nível 1")} 
						register={register} 
						defaultChecked={data?.maa001Adicionanivel1 !== "N"}
						disabled={isDisabled}
					/>
				</RCCGrid>
				<RCCGrid
					container
					item
					md={6}
					xs={12}
				>
					<RCCSwitch styleInline="margin: 10px 10px"
						name="maa001Ativo" 
						label={translate("Ativo")} 
						register={register} 
						defaultChecked={data?.maa001Ativo !== "N"}
						disabled={isDisabled}
					/>
				</RCCGrid>
				{
					superUser && businessGroup.efa001Id === 1 &&
					<RCCGrid
						container
						item
						md={6}
						xs={12}
					>
						<RCCSwitch styleInline="margin: 10px 10px"
							name="maa001Analisemodelo" 
							label={translate("Modelo")} 
							register={register} 
							defaultChecked={data?.maa001Analisemodelo === "S"}
							disabled={isDisabled}
						/>
					</RCCGrid>
				}
			</RCCGrid>
			
			<RCCGrid
				container
				item
				sm={10}
				xs={12}
				styleInline="margin-top: 20px !important"
			>
				<Title color="purple" size="sm" >
					{translate("SWOT")}
				</Title>
				<hr/>

				<RCCGrid
					container
					item
					xs={6}
				>
					<RCCSwitch styleInline="margin: 10px 10px"
						name="maa001Ameaca" 
						label={translate("Ameaça")} 
						register={register} 
						defaultChecked={data?.maa001Ameaca !== "N"}
						disabled={isDisabled}
					/>
				</RCCGrid>
				<RCCGrid
					container
					item
					xs={6}
				>
					<RCCSwitch styleInline="margin: 10px 10px"
						name="maa001Oportunidade" 
						label={translate("Oportunidade")} 
						register={register} 
						defaultChecked={data?.maa001Oportunidade !== "N"}
						disabled={isDisabled}
					/>
				</RCCGrid>
				<RCCGrid
					container
					item
					xs={6}
				>
					<RCCSwitch styleInline="margin: 10px 10px"
						name="maa001Forca" 
						label={translate("Força")} 
						register={register} 
						defaultChecked={data?.maa001Forca !== "N"}
						disabled={isDisabled}
					/>
				</RCCGrid>
				<RCCGrid
					container
					item
					xs={6}
				>
					<RCCSwitch styleInline="margin: 10px 10px"
						name="maa001Fraqueza" 
						label={translate("Fraqueza")} 
						register={register} 
						defaultChecked={data?.maa001Fraqueza !== "N"}
						disabled={isDisabled}
					/>
				</RCCGrid>
			</RCCGrid>
		</RCCGrid>
	);
};

export default TabAnalysisGeneral;
